module.exports = __webpack_public_path__ + "img/exhaustPipe-1.9efb0c61.jpg";